module.exports = __webpack_public_path__ + "img/img-widget-feedback.3634c8b2.svg";